import { Input as AntInput } from 'antd'
import { TextAreaProps } from 'antd/lib/input'
import { ReactNode, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { getGuiId } from 'utils'

const StyledTextArea = styled(AntInput.TextArea)`
  &.prevent-edit {
    color: inherit;
    background-color: inherit;
    cursor: not-allowed;
    textarea {
      pointer-events: none;
      cursor: not-allowed;
    }
  }
  margin-top: 4px;
`

const StyledLabel = styled.label`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
  span {
    color: var(--color-red-107);
  }
`
interface IProps extends TextAreaProps {
  title?: string
  children?: ReactNode
  placeholder?: string
  required?: boolean
  preventInput?: boolean
}

const TextArea = (props: IProps) => {
  const idInput = useRef(getGuiId())
  const preventInputRef = useRef<any>()
  const { t } = useTranslation()
  const {
    title,
    required,
    placeholder,
    preventInput,
    onChange,
    maxLength,
    value,
    ...resPros
  } = props
  const valueRef = useRef<any>(value)

  const handleOnChange = (e: any) => {
    if (preventInputRef.current) return
    onChange && onChange(e)
  }
  useEffect(() => {
    const handleOnKeyPress = (e: any) => {
      const isArrowKey =
        e.key === 'ArrowLeft' ||
        e.key === 'ArrowRight' ||
        e.key === 'ArrowUp' ||
        e.key === 'ArrowDown'
      if (isArrowKey) {
        preventInputRef.current = false
        return
      }

      if (e.key === 'Backspace') {
        preventInputRef.current = false
        return
      }
      if (maxLength && valueRef.current?.length >= maxLength) {
        e.preventDefault()
        preventInputRef.current = true
        return
      }
      preventInputRef.current = false
    }
    const element = document.getElementById(idInput.current)
    element?.addEventListener('keydown', handleOnKeyPress)
    return () => {
      element?.removeEventListener('keydown', handleOnKeyPress)
    }
  }, [])

  useEffect(() => {
    valueRef.current = value
  }, [value])
  return (
    <>
      <StyledLabel>
        {t(title || '')} {required && <span>*</span>}
      </StyledLabel>
      <StyledTextArea
        value={value}
        maxLength={maxLength}
        className={preventInput ? 'prevent-edit' : ''}
        placeholder={t(placeholder || '')}
        onChange={handleOnChange}
        {...resPros}
        id={idInput.current}
      />
    </>
  )
}

export default TextArea
